import { waitValue } from '@/utils/promises'

export default {
  props: {
    badgeValue: { type: Number },
    isFilterInit: { type: Boolean },
    filters: { type: Object, required: true }
  },
  watch: {
    filters: {
      immediate: true,
      handler () {
        if (!this.isFilterInit) {
          return
        }
        return this.getGrid()
          .then((grid) => {
            grid.loadData()
          })
      }
    }
  },
  methods: {
    getRequestMiddleware (getCallback) {
      this.$asyncExecutor.run(getCallback)
    },
    addParamsToGetRequest () {
      const { date, employeeID } = this.filters
      const params = {
        date,
        employeeID
      }
      return JSON.parse(JSON.stringify(params))
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handlerGetData (value, total) {
      this.$emit('update:badgeValue', total)
    }
  }
}
